import {
	Bug,
	ChevronDown,
	ChevronRight,
	Cpu,
	Download,
	FolderOpen,
	Hammer,
	Moon,
	Sun,
	Terminal,
	X,
} from 'lucide-react';
import type { CSSProperties } from 'react';

const icons = {
	sun: Sun,
	moon: Moon,
	terminal: Terminal,
	memory: Cpu,
	chevron: ChevronRight,
	download: Download,
	hammer: Hammer,
	bug: Bug,
	close: X,
	'folder-open': FolderOpen,
	'chevron-down': ChevronDown,
} as const;

export function Icon({
	name,
	size = 16,
	style,
}: {
	name: keyof typeof icons;
	size?: number;
	style?: CSSProperties;
}) {
	const Component = icons[name];
	return (
		<Component className="icon" size={size} strokeWidth={1.7} aria-hidden="true" style={style} />
	);
}
